import React from 'react'
import styled from 'styled-components'

const UnauthorizedPage: React.FunctionComponent = () => {
  return (
    <UnauthorizedContainer>
      <h1>Unauthorized</h1>
      <UnauthorizedSubHeader>
        You do not have permission to view this page.
      </UnauthorizedSubHeader>
    </UnauthorizedContainer>
  )
}

// TODO unify navbar spacing top-level
const UnauthorizedContainer = styled.div`
  margin-top: 64px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`

const UnauthorizedSubHeader = styled.span`
  color: gray;
`

export default UnauthorizedPage
